import type { OrderByModel } from "@tsmono/inspect-common/query";

import type { DatabaseListingPlan } from "../../../client/database/listing";

import { compareByOrderBy, compileCondition } from "./evaluator";
import type { ListingQuery } from "./types";

/**
 * Compile the wire filter and ordering into record-level listing operations.
 *
 * `compare` has no position tiebreak: executors sort stably over the
 * source's listing order, so ties (and the unsorted listing) keep it.
 */
export const createListingPlan = <TRow>(
  query: ListingQuery<TRow>
): DatabaseListingPlan<TRow> => {
  const { filter, getValue, getFilterType, getComparator, pagination } = query;
  const orderBy: OrderByModel[] = query.orderBy
    ? Array.isArray(query.orderBy)
      ? query.orderBy
      : [query.orderBy]
    : [];

  return {
    matches: filter
      ? compileCondition(filter, getValue, getFilterType)
      : () => true,
    compare:
      orderBy.length > 0
        ? compareByOrderBy(orderBy, getValue, getComparator)
        : undefined,
    pagination,
  };
};
